import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import locatii from '../date/locatii.json';

function Cautare() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [anunturi, setAnunturi] = useState([]);
  const [incarca, setIncarca] = useState(true);

  const [filtre, setFiltre] = useState({
    cautare: searchParams.get('q') || '',
    categorie: searchParams.get('cat') || '',
    subcategorie: searchParams.get('subcat') || '',
    pretMin: searchParams.get('min') || '',
    pretMax: searchParams.get('max') || '',
    stare: searchParams.get('stare') || '',
    tipOferta: searchParams.get('tipOferta') || '',
    tipPersoana: searchParams.get('tipPersoana') || '',
    judet: searchParams.get('judet') || '',
    localitate: searchParams.get('localitate') || ''
  });

  const [sortare, setSortare] = useState(searchParams.get('sortare') || 'nou');

  const judete = Object.keys(locatii).sort();

  const localitatiDisponibile = [];
  if (filtre.judet && locatii[filtre.judet]) {
    const toateLocalitatile = locatii[filtre.judet];
    for (let i = 0; i < toateLocalitatile.length; i++) {
      localitatiDisponibile.push(toateLocalitatile[i]);
    }
  }

  const categoriileLista = [
    { nume: 'Auto, moto si ambarcatiuni', subcategorii: ["Autoturisme", "Autoutilitare", "Camioane - Rulote - Remorci", "Motociclete", "Scutere - ATV - UTV", "Ambarcatiuni", "Utilaje agricole si industriale"] },
    { nume: 'Imobiliare', subcategorii: ["Apartamente - Garsoniere de vanzare", "Apartamente - Garsoniere de inchiriat", "Case de vanzare", "Case de inchiriat", "Terenuri", "Spatii comerciale", "Birouri - Spatii industriale", "Cazare - Turism"] },
    { nume: 'Locuri de munca', subcategorii: ["IT - Telecomunicatii", "Inginerie - Arhitectura", "Vanzari", "Administrativ - Secretariat", "Finante - Contabilitate", "Transport - Logistica", "Constructii - Meseriasi", "Horeca", "Personal medical"] },
    { nume: 'Electronice si electrocasnice', subcategorii: ["Telefoane", "Electrocasnice", "Tablete - eReadere", "TV", "Videoproiectoare & Accesorii", "Retelistica & Servere", "Piese telefoane & tablete", "Laptop-Calculator-Gaming", "Ingrijire Personala", "Periferice & Accesorii Laptop-PC-Gaming", "Imprimante, scannere", "Home Cinema & Audio", "Gadgets, Wearables & Camere foto-video", "Drone & accesorii", "Componente Laptop-PC", "Casti Audio", "Casa inteligenta - Smarthome", "Audio Hi Fi & Profesionale", "Aparate medicale & Wellness", "Accesorii telefoane & tablete"] },
    { nume: 'Moda si frumusete', subcategorii: ["Incaltaminte barbati", "Haine barbati", "Incaltaminte dama", "Haine dama", "Bijuterii - Accesorii", "Cosmetice - Parfumuri", "Rochii de mireasa"] },
    { nume: 'Piese auto', subcategorii: ["Piese auto", "Roti - Jante - Anvelope", "Consumabile - Accesorii", "Sisteme Audio - Navigatie", "Echipamente si accesorii moto"] },
    { nume: 'Casa si gradina', subcategorii: ["Mobila - Decoratiuni", "Materiale constructii si amenajari", "Unelte - Scule - Feronerie", "Termice - Electrice - Sanitare", "Gradina", "Articole menaj"] },
    { nume: 'Mama si copilul', subcategorii: ["Haine - Incaltaminte copii", "Carucioare - Landouri", "Camera copilului", "Jucarii", "Alimentatie - Ingrijire", "Articole scolare"] },
    { nume: 'Sport, timp liber, arta', subcategorii: ["Biciclete - Fitness - Suplimente", "Echipamente sportive", "Turism - Echipamente", "Arta - Obiecte de colectie", "Instrumente muzicale", "Carti - Muzica - Filme"] },
    { nume: 'Animale de companie', subcategorii: ["Caini", "Pisici", "Animale de ferma", "Pasari", "Pesti", "Alte animale", "Accesorii si hrana"] },
    { nume: 'Servicii', subcategorii: ["Auto - Transport", "Meseriasi - Constructori", "Reparatii IT - Electronice", "Evenimente - Divertisment", "Cursuri - Meditatii", "Servicii de curatenie", "Servicii de infrumusetare"] },
  ];

  const subcategoriiDisponibile = [];
  if (filtre.categorie) {
    for (let i = 0; i < categoriileLista.length; i++) {
      if (categoriileLista[i].nume === filtre.categorie) {
        for (let j = 0; j < categoriileLista[i].subcategorii.length; j++) {
          subcategoriiDisponibile.push(categoriileLista[i].subcategorii[j]);
        }
        break;
      }
    }
  }

  const categorii = [
    "Auto, moto si ambarcatiuni", "Imobiliare", "Locuri de munca",
    "Electronice si electrocasnice", "Moda si frumusete", "Piese auto",
    "Casa si gradina", "Mama si copilul", "Sport, timp liber, arta",
    "Animale de companie", "Servicii"
  ];

  const stari = ["Nou", "Utilizat"];
  const oferte = ["Vinde", "Cumpara", "Inchiriaza"];
  const vanzatori = ["Persoana fizica", "Firma"];

  useEffect(function() {
    preiaAnunturi();
  }, [searchParams]);

  async function preiaAnunturi() {
    setIncarca(true);
    try {
      const query = new URLSearchParams();

      const q = searchParams.get('q') || '';
      const cat = searchParams.get('cat') || '';
      const subcat = searchParams.get('subcat') || '';
      const min = searchParams.get('min') || '';
      const max = searchParams.get('max') || '';
      const stare = searchParams.get('stare') || '';
      const tipOferta = searchParams.get('tipOferta') || '';
      const tipPersoana = searchParams.get('tipPersoana') || '';
      const judet = searchParams.get('judet') || '';
      const localitate = searchParams.get('localitate') || '';
      const sort = searchParams.get('sortare') || 'nou';

      if (q) { query.append('cautare', q); }
      if (cat) { query.append('cat', cat); }
      if (subcat) { query.append('subcat', subcat); }
      if (min) { query.append('min', min); }
      if (max) { query.append('max', max); }
      if (stare) { query.append('stare', stare); }
      if (tipOferta) { query.append('tipOferta', tipOferta); }
      if (tipPersoana) { query.append('tipPersoana', tipPersoana); }
      if (judet) { query.append('judet', judet); }
      if (localitate) { query.append('localitate', localitate); }
      if (sort) { query.append('sortare', sort); }

      const raspuns = await fetch('https://tranzitio.onrender.com/api/anunturi/toate?' + query.toString());
      if (raspuns.ok) {
        const date = await raspuns.json();
        setAnunturi(date);
      } else {
        toast.error('Eroare la incarcarea rezultatelor');
      }
    } catch (eroare) {
      toast.error('Eroare de conexiune');
    } finally {
      setIncarca(false);
    }
  }

  function aplicaFiltrele(e) {
    if (e) {
      e.preventDefault();
    }
    const parametriNoi = new URLSearchParams();
    if (filtre.cautare) { parametriNoi.set('q', filtre.cautare); }
    if (filtre.categorie) { parametriNoi.set('cat', filtre.categorie); }
    if (filtre.subcategorie) { parametriNoi.set('subcat', filtre.subcategorie); }
    if (filtre.pretMin) { parametriNoi.set('min', filtre.pretMin); }
    if (filtre.pretMax) { parametriNoi.set('max', filtre.pretMax); }
    if (filtre.stare) { parametriNoi.set('stare', filtre.stare); }
    if (filtre.tipOferta) { parametriNoi.set('tipOferta', filtre.tipOferta); }
    if (filtre.tipPersoana) { parametriNoi.set('tipPersoana', filtre.tipPersoana); }
    if (filtre.judet) { parametriNoi.set('judet', filtre.judet); }
    if (filtre.localitate) { parametriNoi.set('localitate', filtre.localitate); }
    if (sortare) { parametriNoi.set('sortare', sortare); }
    setSearchParams(parametriNoi);
  }

  function schimbaSortarea(valoareNoua) {
    setSortare(valoareNoua);
    const parametriNoi = new URLSearchParams(searchParams);
    parametriNoi.set('sortare', valoareNoua);
    setSearchParams(parametriNoi);
  }

  function reseteazaFiltrele() {
    setFiltre({
      cautare: '',
      categorie: '',
      subcategorie: '',
      pretMin: '',
      pretMax: '',
      stare: '',
      tipOferta: '',
      tipPersoana: '',
      judet: '',
      localitate: ''
    });
    setSortare('nou');
    setSearchParams({});
  }

  function handleSchimbaFiltru(numeCamp, valoare) {
    const filtreNoi = { ...filtre };
    filtreNoi[numeCamp] = valoare;
    setFiltre(filtreNoi);
  }

  function handleSchimbaCategorie(categorieNoua) {
    const filtreNoi = { ...filtre };
    filtreNoi.categorie = categorieNoua;
    filtreNoi.subcategorie = '';
    setFiltre(filtreNoi);
  }

  function handleSchimbaJudet(judetNou) {
    const filtreNoi = { ...filtre };
    filtreNoi.judet = judetNou;
    filtreNoi.localitate = '';
    setFiltre(filtreNoi);
  }

  return (
    <div className="min-h-screen bg-[#f8fafc] py-8 font-sans text-gray-900">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">

        <div className="mb-8">
          <div className="flex items-center gap-2 text-sm font-medium text-gray-500 mb-2">
            <Link to="/" className="hover:text-blue-600 transition">Acasa</Link>
            <svg className="w-4 h-4 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
            <span className="text-gray-900">Cautare</span>
          </div>
          <h1 className="text-3xl font-black text-gray-900 tracking-tight">
            Rezultate cautare {filtre.cautare && <span className="text-blue-600">"{filtre.cautare}"</span>}
          </h1>
          <p className="text-gray-500 mt-1 font-medium">Am gasit {anunturi.length} oferte active</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">

          <div className="w-full lg:w-1/4">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 lg:sticky lg:top-24">
              <h2 className="text-lg font-black text-gray-900 mb-6 flex items-center gap-2 border-b border-gray-100 pb-4">
                <svg className="w-5 h-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                </svg>
                Filtre Avansate
              </h2>

              <form onSubmit={aplicaFiltrele} className="flex flex-col gap-5">

                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">Cuvant cheie</label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </div>
                    <input
                      type="text"
                      value={filtre.cautare}
                      onChange={function(e) { handleSchimbaFiltru('cautare', e.target.value); }}
                      placeholder="Ce cauti?"
                      className="w-full border border-gray-200 rounded-xl pl-10 pr-4 py-2.5 text-sm focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-gray-50 transition-colors"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">Judet</label>
                  <select
                    value={filtre.judet}
                    onChange={function(e) { handleSchimbaJudet(e.target.value); }}
                    className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-blue-600 bg-gray-50 text-gray-700 transition-colors"
                  >
                    <option value="">Toate judetele</option>
                    {judete.map(function(j) {
                      return <option key={j} value={j}>{j}</option>;
                    })}
                  </select>
                </div>

                {filtre.judet && (
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">Localitate</label>
                    <select
                      value={filtre.localitate}
                      onChange={function(e) { handleSchimbaFiltru('localitate', e.target.value); }}
                      className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-blue-600 bg-gray-50 text-gray-700 transition-colors"
                    >
                      <option value="">Toate localitatile</option>
                      {localitatiDisponibile.map(function(l) {
                        return <option key={l} value={l}>{l}</option>;
                      })}
                    </select>
                  </div>
                )}

                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">Categorie</label>
                  <select
                    value={filtre.categorie}
                    onChange={function(e) { handleSchimbaCategorie(e.target.value); }}
                    className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-blue-600 bg-gray-50 text-gray-700 transition-colors"
                  >
                    <option value="">Toate categoriile</option>
                    {categorii.map(function(cat) {
                      return <option key={cat} value={cat}>{cat}</option>;
                    })}
                  </select>
                </div>

                {filtre.categorie && (
                  <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">Subcategorie</label>
                    <select
                      value={filtre.subcategorie}
                      onChange={function(e) { handleSchimbaFiltru('subcategorie', e.target.value); }}
                      className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-blue-600 bg-gray-50 text-gray-700 transition-colors"
                    >
                      <option value="">Toate subcategoriile</option>
                      {subcategoriiDisponibile.map(function(sub) {
                        return <option key={sub} value={sub}>{sub}</option>;
                      })}
                    </select>
                  </div>
                )}

                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">Pret (RON)</label>
                  <div className="flex items-center gap-2">
                    <input
                      type="number"
                      value={filtre.pretMin}
                      onChange={function(e) { handleSchimbaFiltru('pretMin', e.target.value); }}
                      placeholder="Min"
                      className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:border-blue-600 bg-gray-50 transition-colors"
                    />
                    <span className="text-gray-400 font-bold">-</span>
                    <input
                      type="number"
                      value={filtre.pretMax}
                      onChange={function(e) { handleSchimbaFiltru('pretMax', e.target.value); }}
                      placeholder="Max"
                      className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:border-blue-600 bg-gray-50 transition-colors"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">Stare</label>
                  <select
                    value={filtre.stare}
                    onChange={function(e) { handleSchimbaFiltru('stare', e.target.value); }}
                    className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-blue-600 bg-gray-50 text-gray-700 transition-colors"
                  >
                    <option value="">Orice stare</option>
                    {stari.map(function(st) {
                      return <option key={st} value={st}>{st}</option>;
                    })}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">Tip oferta</label>
                  <select
                    value={filtre.tipOferta}
                    onChange={function(e) { handleSchimbaFiltru('tipOferta', e.target.value); }}
                    className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-blue-600 bg-gray-50 text-gray-700 transition-colors"
                  >
                    <option value="">Orice oferta</option>
                    {oferte.map(function(of) {
                      return <option key={of} value={of}>{of}</option>;
                    })}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">Vanzator</label>
                  <select
                    value={filtre.tipPersoana}
                    onChange={function(e) { handleSchimbaFiltru('tipPersoana', e.target.value); }}
                    className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-blue-600 bg-gray-50 text-gray-700 transition-colors"
                  >
                    <option value="">Oricine</option>
                    {vanzatori.map(function(van) {
                      return <option key={van} value={van}>{van}</option>;
                    })}
                  </select>
                </div>

                <div className="pt-4 border-t border-gray-100 flex flex-col gap-3 mt-2">
                  <button
                    type="submit"
                    className="w-full bg-blue-600 text-white font-bold py-3.5 rounded-xl hover:bg-blue-700 transition shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                  >
                    Aplica filtrele
                  </button>
                  <button
                    type="button"
                    onClick={reseteazaFiltrele}
                    className="w-full bg-white border border-gray-200 text-gray-700 font-bold py-3.5 rounded-xl hover:bg-gray-50 transition"
                  >
                    Reseteaza
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="w-full lg:w-3/4">
            <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-200 mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
              <p className="text-gray-600 font-medium text-sm">
                Afisare <span className="font-bold text-gray-900">{anunturi.length}</span> oferte disponibile
                {filtre.judet && (
                  <span className="text-blue-600 ml-1">
                    in {filtre.localitate ? filtre.localitate : filtre.judet}
                  </span>
                )}
              </p>
              <div className="flex items-center gap-3 w-full sm:w-auto">
                <label className="text-sm font-bold text-gray-600 whitespace-nowrap">Ordoneaza:</label>
                <select
                  value={sortare}
                  onChange={function(e) { schimbaSortarea(e.target.value); }}
                  className="w-full sm:w-auto border border-gray-200 rounded-lg px-4 py-2 text-sm font-medium focus:outline-none focus:border-blue-600 bg-gray-50 text-gray-800"
                >
                  <option value="nou">Cele mai noi primele</option>
                  <option value="pret_cresc">Pret: Crescator</option>
                  <option value="pret_desc">Pret: Descrescator</option>
                </select>
              </div>
            </div>

            {incarca ? (
              <div className="flex justify-center items-center py-32">
                <div className="flex flex-col items-center gap-4">
                  <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
                  <p className="text-gray-500 font-bold">Cautam cele mai bune oferte...</p>
                </div>
              </div>
            ) : anunturi.length === 0 ? (
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-16 text-center">
                <div className="w-24 h-24 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg className="w-12 h-12 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-black text-gray-900 mb-2">Nu am gasit niciun rezultat</h2>
                <p className="text-gray-500 font-medium mb-6">Incearca sa modifici filtrele sau sa alegi o alta locatie.</p>
                <button
                  onClick={reseteazaFiltrele}
                  className="bg-blue-50 text-blue-700 font-bold px-6 py-3 rounded-xl hover:bg-blue-100 transition"
                >
                  Sterge toate filtrele
                </button>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {anunturi.map(function(anunt) {
                  let pozaAflisata = '';
                  if (Array.isArray(anunt.imagini) && anunt.imagini.length > 0) {
                    pozaAflisata = anunt.imagini[0];
                  } else if (anunt.imagine) {
                    pozaAflisata = anunt.imagine;
                  }

                  return (
                    <Link key={anunt._id} to={'/anunt/' + anunt._id} className="group bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col h-full relative border border-gray-100">
                      <div className="relative aspect-[4/3] overflow-hidden bg-gray-50">
                        {pozaAflisata ? (
                          <img src={pozaAflisata} alt={anunt.titlu} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" />
                        ) : (
                          <div className="w-full h-full flex flex-col items-center justify-center text-gray-400">
                            <svg className="w-10 h-10 mb-2 opacity-50" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                            <span className="text-sm font-medium">Fara imagine</span>
                          </div>
                        )}
                        <div className="absolute top-3 left-3 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-lg text-xs font-black text-gray-800 shadow-sm uppercase tracking-wider">
                          {anunt.categorie}
                        </div>
                        {anunt.stare === 'Nou' && (
                          <div className="absolute bottom-3 left-3 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-md shadow-sm">
                            Nou
                          </div>
                        )}
                      </div>
                      <div className="p-5 flex flex-col flex-grow">
                        <h4 className="font-bold text-gray-900 leading-snug line-clamp-2 mb-4 group-hover:text-blue-600 transition-colors">
                          {anunt.titlu}
                        </h4>
                        <div className="mt-auto flex items-end justify-between">
                          <div className="bg-blue-50 px-3 py-1.5 rounded-lg">
                            <p className="text-xl font-black text-blue-700">
                              {anunt.pret} <span className="text-sm font-bold">{anunt.moneda || 'RON'}</span>
                            </p>
                          </div>
                          <div className="text-right">
                            <p className="text-xs text-gray-500 font-medium flex items-center gap-1 justify-end">
                              <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                              </svg>
                              {anunt.localitate || 'Nespecificat'}
                            </p>
                            {anunt.judet && (
                              <p className="text-xs text-gray-400 mt-0.5">{anunt.judet}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </Link>
                  );
                })}
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}

export default Cautare;